/* eslint-disable camelcase */
import { SchoolsForRemoveGradeLevelRequirements } from './district-course-request/remove-requirements/schools-for-remove-grade-level-requirements.model';
import { Injectable, EventEmitter } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { System } from '../../../shared-components/System';
import { CourseRequestDistrictGradeLevelCreditsDTO } from './models/districtGradeLevelCreditsSource.model';
import {
    CourseRequestDistrictGradeLevelRequirementsDTO,
    DistrictCoursesForRequirementDTO,
    SchoolsForRequirementAssignmentDTO
} from './models/districtGradeLevelRequirements.model';
import { YearService } from '../../../shared-components/year/year.service';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';
import { SchoolCourseRequestModel } from './models/school-course-request-model';
import { UserService } from '../../../shared-components/user/user.service';
import { SchoolGradeLevelCreditsDTO } from './models/schoolGradeLevelCredits.model';
import { SchoolGradeLevelRequirementDTO } from './models/schoolGradeLevelRequirement.model';
import { LoginService } from '../../../shared-modules/login/login.service';
import { RequestTallyCourseHeaderDTO } from './models/requestTallyCourse.model';
import { RequestConflictModelDTO } from './models/requestConflict.model';
import { SchoolStaffDTO } from './models/SchoolStaff.model';
import { SchoolTermsDTO } from './models/schoolTerms.model';
import {
    CourseRequestStudentSummarySpecialStudentFilterModel,
    CourseRequestStudentSummaryModel,
    MassAddCourseRequestsDTO,
    CourseRequestStudentSummaryFilterModel
} from './models/courserequestStudentSummary.model';
import { RebuildRequestConflictParametersDTO } from './models/rebuildRequestConflictParameters.model';
import { ScheduleFolderService } from '../schedule-folder/schedule-folder.service';
import { IdentifiedConflictsDTO } from './models/identifiedConflicts.model';
import { StudentScheduleProgressDTO } from '../shared/student-schedule-progress/student-schedule-progress.model';
import { StudentSchedulingParameters } from '../shared/student-scheduling-parameters.model';
import { ClearStudentSectionsDTO } from './models/clear-student-sections.model';
import { map, take } from 'rxjs/operators';

@Injectable()
export class CourseRequestMgmtService {


    // any course request changes made on the Course Request tab
    // increment _requestsChanged +1
    private _requestsChanged = 0;
    public observableRequestsChanged = new Subject<number>();
    observableRequestsChangedStream$ = this.observableRequestsChanged.asObservable();

    get requestsChanged(): number {
        return this._requestsChanged;
    }

    set requestsChanged(value: number) {
        this._requestsChanged = value;
        this.observableRequestsChanged.next(this._requestsChanged);
    }

    // any course request changes made on the Student Summary tab
    // increment _studentSummaryRequestsChanged +1
    private _studentSummaryRequestsChanged = 0;
    public observableStudentSummaryRequestsChanged = new Subject<number>();
    observableStudentSummaryRequestsChangedStream$ = this.observableStudentSummaryRequestsChanged.asObservable();

    get studentSummaryRequestsChanged(): number {
        return this._studentSummaryRequestsChanged;
    }

    set studentSummaryRequestsChanged(value: number) {
        this._studentSummaryRequestsChanged = value;
        this.observableStudentSummaryRequestsChanged.next(this._studentSummaryRequestsChanged);
    }

    districtCourses: DistrictCoursesForRequirementDTO[];
    schoolCourses: DistrictCoursesForRequirementDTO[];
    creditsDecimalPlaces = 2;

    modifyRequirementEvent = new EventEmitter();
    OnNavigateToStudentSummaryTab = new EventEmitter<CourseRequestStudentSummarySpecialStudentFilterModel>();
    OnNavigateToStudentCourseRequestTab = new EventEmitter();

    schoolCRM_selectedTab: string;
    districtCRM_selectedTab: string;

    // permissions
    allow_DistrictCourseRequestSetupWrite = true;
    allow_GradeLevelCourseRequestSetupWrite = true;

    // Filter Properties
    studentSummarySpecialFilter: CourseRequestStudentSummarySpecialStudentFilterModel;
    studentSummaryFilter = new CourseRequestStudentSummaryFilterModel();

    constructor(
        private http: HttpClient, private yearService: YearService,
        private userService: UserService,
        private loginService: LoginService,
        private scheduleFolderService: ScheduleFolderService
    ) {
    }

    isTabSelected(tab): boolean {
        return this.schoolCRM_selectedTab === tab;
    }

    isDistrictTabSelected(tab): boolean {
        return this.districtCRM_selectedTab === tab;
    }

    getDistrictGradeLevelCredits(): Observable<CourseRequestDistrictGradeLevelCreditsDTO[]> {
        return this.http.get<CourseRequestDistrictGradeLevelCreditsDTO[]>(System.apiURL.Counselor + 'GetCourseRequestDistrictGradeLevelCredits?ayIdentifier=' + this.yearService.defaultYear.AYIdentifier);
    }

    updateDistrictGradeLevelCredits(data: CourseRequestDistrictGradeLevelCreditsDTO[]): Observable<void> {
        const queryString = '?ayIdentifier=' + this.yearService.defaultYear.AYIdentifier;
        return this.http.post<void>(System.apiURL.Counselor + 'UpdateCourseRequestDistrictGradeLevelCredits' + queryString, data);
    }

    /* getCourseRequestGetDistrictGradeLevelRequirements(): Observable<CourseRequestDistrictGradeLevelRequirementsDTO[]> {
        return this.getCourseRequestGetDistrictGradeLevelRequirementsBySchool(-1);
    } */

    getCourseRequestGetDistrictGradeLevelRequirementsBySchool(school_Id: number): Observable<CourseRequestDistrictGradeLevelRequirementsDTO[]> {
        return this.http.get<CourseRequestDistrictGradeLevelRequirementsDTO[]>(System.apiURL.Counselor + 'GetCourseRequestGetDistrictGradeLevelRequirements?ayIdentifier=' + this.yearService.defaultYear.AYIdentifier + '&siteId=' + school_Id);
    }

    getCourseRequestGetDistrictGradeLevelRequirementsByYear(ayIdentifier: string): Observable<CourseRequestDistrictGradeLevelRequirementsDTO[]> {
        return this.http.get<CourseRequestDistrictGradeLevelRequirementsDTO[]>(System.apiURL.Counselor + 'GetCourseRequestGetDistrictGradeLevelRequirements?ayIdentifier=' + ayIdentifier + '&siteId=-1');
    }


    getSchoolsForRequirementAssignment(requirements: string): Observable<SchoolsForRequirementAssignmentDTO[]> {
        return this.http.get<SchoolsForRequirementAssignmentDTO[]>(System.apiURL.Counselor + 'GetSchoolsForRequirementAssignment?requirements=' + requirements);
    }

    assignSchoolToRequirements(requirements: string, schools: number[]): Observable<void> {
        return this.http.post<void>(System.apiURL.Counselor + 'AssignSchoolToRequirements?requirements=' + requirements, schools);
    }

    deleteDistrictGradeLevelRequirement(requirement_ID: number): Observable<string> {
        return this.http.get<string>(System.apiURL.Counselor + 'deleteDistrictGradeLevelRequirement?requirementId=' + requirement_ID);
    }

    getCoursesForDistrictRequirement(schoolId = -1): Observable<DistrictCoursesForRequirementDTO[]> {
        return this.http.get<DistrictCoursesForRequirementDTO[]>(System.apiURL.Counselor + 'GetCoursesForDistrictRequirement?ayIdentifier=' + this.yearService.defaultYear.AYIdentifier + '&schoolId=' + schoolId);
    }

    getSchoolCourseRequests(schoolId: number): Observable<SchoolCourseRequestModel[]> {
        return this.http.get<SchoolCourseRequestModel[]>(System.apiURL.Counselor + 'GetSchoolCourseRequests?ayIdentifier=' + this.yearService.defaultYear.AYIdentifier + '&schoolId=' + schoolId);
    }

    deleteSchoolCourseRequests(data: SchoolCourseRequestModel[]): Observable<number> {
        return this.http.post<number>(System.apiURL.Counselor + 'DeleteSchoolCourseRequests', data);
    }

    approveSchoolCourseRequests(data: SchoolCourseRequestModel[]): Observable<number> {
        return this.http.post<number>(System.apiURL.Counselor + 'ApproveSchoolCourseRequests', data);
    }

    updateSchoolCourseRequests(data: SchoolCourseRequestModel[]): Observable<number> {
        return this.http.post<number>(System.apiURL.Counselor + 'UpdateSchoolCourseRequests', data);
    }

    updateDistrictGradeLevelRequirement(data: CourseRequestDistrictGradeLevelRequirementsDTO): Observable<number> {
        return this.http.post<number>(System.apiURL.Counselor + 'UpdateDistrictGradeLevelRequirement?ayIdentifier=' + this.yearService.defaultYear.AYIdentifier, data);
    }

    getSchoolGradeLevelCreditsOverview(siteYear_ID: number): Observable<SchoolGradeLevelCreditsDTO[]> {
        const queryString = '?siteYear_ID=' + siteYear_ID;
        return this.http.get<SchoolGradeLevelCreditsDTO[]>(System.apiURL.Counselor + 'GetSchoolGradeLevelCreditOveriew' + queryString);
    }

    GetSchoolGradeLevelCreditsForAddEdit(schoolId: number): Observable<SchoolGradeLevelCreditsDTO[]> {
        const queryString = '?school_ID=' + schoolId + '&ayIdentifier=' + this.yearService.defaultYear.AYIdentifier;
        return this.http.get<SchoolGradeLevelCreditsDTO[]>(System.apiURL.Counselor + 'GetSchoolGradeLevelCreditsForAddEdit' + queryString);
    }

    UpdateSchoolGradeLevelCredits(updateType: string, data: SchoolGradeLevelCreditsDTO[]): Observable<SchoolGradeLevelCreditsDTO[]> {
        const queryString = '?siteYear_ID=' + ((this.loginService.LoginSettings.V10 == true) ? this.yearService.defaultYear.Id : this.yearService.defaultYear.SiteYearId) + '&updateType=' + updateType;
        return this.http.post<SchoolGradeLevelCreditsDTO[]>(System.apiURL.Counselor + 'UpdateCourseRequestSchoolGradeLevelCredits' + queryString, data);
    }

    GetSchoolGradeLevelRequirements(): Observable<SchoolGradeLevelRequirementDTO[]> {
        const queryString = '?siteYear_ID=' + ((this.loginService.LoginSettings.V10 == true) ? this.yearService.defaultYear.Id : this.yearService.defaultYear.SiteYearId) + '&ayIdentifier=' + this.yearService.defaultYear.AYIdentifier;
        return this.http.get<SchoolGradeLevelRequirementDTO[]>(System.apiURL.Counselor + 'GetSchoolGradeLevelRequirements' + queryString);
    }

    UpdateSchoolGradeLevelRequirement(updateType: string, data: any): Observable<SchoolGradeLevelRequirementDTO[]> {
        const queryString = '?siteYear_ID=' + ((this.loginService.LoginSettings.V10 == true) ? this.yearService.defaultYear.Id : this.yearService.defaultYear.SiteYearId) + '&ayIdentifier=' + this.yearService.defaultYear.AYIdentifier + '&updateType=' + updateType;
        return this.http.post<SchoolGradeLevelRequirementDTO[]>(System.apiURL.Counselor + 'UpdateSchoolGradeLevelRequirement' + queryString, data);
    }

    GetRequestTallyCourses(): Observable<RequestTallyCourseHeaderDTO> {
        const queryString = '?siteYear_ID=' + ((this.loginService.LoginSettings.V10 == true) ? this.yearService.defaultYear.Id : this.yearService.defaultYear.SiteYearId)
            + '&scheduleFolders_ID=' + this.scheduleFolderService.selectedScheduleFolder.ID;
        return this.http.get<RequestTallyCourseHeaderDTO>(System.apiURL.Counselor + 'GetRequestTallyCourses' + queryString);
    }

    getRequestConflicts(schoolId: number, requestParameters: RebuildRequestConflictParametersDTO): Observable<RequestConflictModelDTO[]> {
        // const queryString = '?siteYear_ID=' + ((this.loginService.LoginSettings.V10 == true) ? this.yearService.defaultYear.Id : this.yearService.defaultYear.SiteYearId);
        return this.http.post<RequestConflictModelDTO[]>(System.apiURL.Counselor + 'GetRequestConflicts?ayIdentifier=' + this.yearService.defaultYear.AYIdentifier + '&schoolDomain=' + schoolId, requestParameters);
    }

    getSchoolStaff(schoolDomain: number): Observable<SchoolStaffDTO[]> {
        return this.http.get<SchoolStaffDTO[]>(System.apiURL.Counselor + 'GetSchoolStaff?schoolDomain=' + schoolDomain);
    }

    getSchoolTerms(): Observable<SchoolTermsDTO[]> {
        const queryString = '?siteYear_ID=' + ((this.loginService.LoginSettings.V10 == true) ? this.yearService.defaultYear.Id : this.yearService.defaultYear.SiteYearId);
        return this.http.get<SchoolTermsDTO[]>(System.apiURL.Counselor + 'GetSchoolTerms' + queryString);
    }

    getCourseRequestStudentSummary(scheduleFolders_ID: number, specialFilter: CourseRequestStudentSummarySpecialStudentFilterModel): Observable<CourseRequestStudentSummaryModel[]> {
        const queryString = '?siteYear_ID=' + ((this.loginService.LoginSettings.V10 == true) ? this.yearService.defaultYear.Id : this.yearService.defaultYear.SiteYearId) + '&scheduleFolders_ID=' + scheduleFolders_ID;
        return this.http.post<CourseRequestStudentSummaryModel[]>(System.apiURL.Counselor + 'GetCourseRequestStudentSummary' + queryString, specialFilter);
    }

    AddRemoveCourseRequestInMass(data: any, addedByStudent: boolean, siteYear_ID?: number): Observable<MassAddCourseRequestsDTO> {
        siteYear_ID = siteYear_ID == null ? this.yearService.defaultYear.Id : siteYear_ID;
        const queryString = '?siteYear_ID=' + siteYear_ID + '&AddedByStudent=' + addedByStudent;
        return this.http.post<MassAddCourseRequestsDTO>(System.apiURL.Counselor + 'AddRemoveCourseRequestInMass' + queryString, data);
    }

    RebuildRequestConflicts(schoolId: number, data: RebuildRequestConflictParametersDTO): Observable<number> {
        const queryString = '?schoolDomain=' + schoolId + '&siteYear_ID=' + ((this.loginService.LoginSettings.V10 == true) ? this.yearService.defaultYear.Id : this.yearService.defaultYear.SiteYearId) + '&ayIdentifier=' + this.yearService.defaultYear.AYIdentifier;
        return this.http.post<number>(System.apiURL.Counselor + 'RebuildRequestConflicts' + queryString, data);
    }

    OverrideConflicts(data: IdentifiedConflictsDTO[]): Observable<number> {
        const queryString = '?siteYear_ID=' + ((this.loginService.LoginSettings.V10 == true) ? this.yearService.defaultYear.Id : this.yearService.defaultYear.SiteYearId);
        return this.http.post<number>(System.apiURL.Counselor + 'OverrideConflicts' + queryString, data);
    }

    checkStudentScheduleBatch() {
        const queryString = '?scheduleFolders_ID=' + this.scheduleFolderService.selectedScheduleFolder.ID;
        return this.http.get<number[]>(System.apiURL.Counselor + 'CheckStudentScheduleBatch' + queryString);
    }

    createStudentScheduleBatch(scheduleFolders_ID: number, data: StudentSchedulingParameters): Observable<number[]> {
        const queryString = '?scheduleFolders_ID=' + scheduleFolders_ID;
        // const data  = [];
        // data.push(StudentIDs);
        return this.http.post<number[]>(System.apiURL.Counselor + 'CreateStudentScheduleBatch' + queryString, data);
    }

    getStudentScheduleBatchData(Batch_ID: number): Observable<StudentScheduleProgressDTO> {
        const queryString = '?Batch_ID=' + Batch_ID;
        return this.http.get<StudentScheduleProgressDTO>(System.apiURL.Counselor + 'GetStudentScheduleBatchData' + queryString);
    }

    performStudentScheduling(data: StudentSchedulingParameters): Observable<number> {
        const queryString = '?scheduleFolder_ID=' + this.scheduleFolderService.selectedScheduleFolder.ID;
        return this.http.post<number>(System.apiURL.Counselor + 'PerformStudentScheduling' + queryString, data);
    }

    processStudentScheduleBatch(batch_ID: number, includeAlternateRequests: boolean, data: StudentSchedulingParameters): Observable<number> {
        const queryString = '?batch_ID=' + batch_ID + '&includeAlternateRequests=' + includeAlternateRequests;
        return this.http.post<number>(System.apiURL.Counselor + 'ProcessStudentScheduleBatch' + queryString, data);
    }

    stopStudentScheduleBatch(batch_ID: number): Observable<number> {
        const queryString = '?batch_ID=' + batch_ID;
        return this.http.get<number>(System.apiURL.Counselor + 'StopStudentScheduleBatch' + queryString);
    }

    saveStudentScheduleBatch(batch_ID: number): Observable<number> {
        const queryString = '?batch_ID=' + batch_ID;
        return this.http.get<number>(System.apiURL.Counselor + 'SaveStudentScheduleBatch' + queryString);
    }

    rejectStudentScheduleBatch(batch_ID: number): Observable<number> {
        const queryString = '?batch_ID=' + batch_ID;
        return this.http.get<number>(System.apiURL.Counselor + 'RejectStudentScheduleBatch' + queryString);
    }

    getNumberMask() {
        return {
            guide: true,
            mask: createNumberMask({
                prefix: '',
                includeThousandsSeparator: false,
                integerLimit: 2,
                allowDecimal: true,
                decimalLimit: this.creditsDecimalPlaces
            })
        };
    }

    getCreditFormatPipString() {
        return '1.' + this.creditsDecimalPlaces.toString();
    }

    clearStudentSchedule(scheduleFoldersId: number, studentIds: number[]) {
        const queryString = '?scheduleFoldersId=' + scheduleFoldersId;
        return this.http.post<ClearStudentSectionsDTO>(System.apiURL.Counselor + 'ClearStudentSections' + queryString, studentIds);
    }

    massAddRequiredCourseRequests(studentIds: number[]) {
        const queryString = '?siteYearId=' + ((this.loginService.LoginSettings.V10 == true) ? this.yearService.defaultYear.Id : this.yearService.defaultYear.SiteYearId);
        return this.http.post<number>(System.apiURL.Counselor + 'MassAddRequiredCourseRequests' + queryString, studentIds);
    }

    getSchoolsForRemoveGradeLevelRequirements(gradeLevelRequirementId: number) {
        const queryString = '?yearId=' + this.yearService.defaultYear.Id
            + '&gradeLevelRequirementId=' + gradeLevelRequirementId;
        return this.http.get<SchoolsForRemoveGradeLevelRequirements[]>(
            System.apiURL.Counselor + 'GetSchoolsForRemoveGradeLevelRequirements' + queryString
        ).pipe(
            take(1),
            map(schools => {
                for (let i = 0; i < schools.length; i++) {
                    schools[i] = System.convert(schools[i], new SchoolsForRemoveGradeLevelRequirements());
                }
                return schools;
            })
        );
    }

    removeGradeLevelRequirementsForSchools(sites: number[], gradeLevelRequirementId: number) {
        const queryString = '?gradeLevelRequirementId=' + gradeLevelRequirementId;
        return this.http.post<void[]>(
            System.apiURL.Counselor + 'RemoveGradeLevelRequirementsFromSchools' + queryString,
            sites
        ).pipe(
            take(1)
        );
    }
}
